module.exports = __webpack_public_path__ + "static/media/user.3d07a9c4.svg";